import { gql } from '@apollo/client'

export const UPDATE_PRICE_LIST = gql`
  mutation updatePricingPlan($id: ID!, $name: String!, $pricings: [PricingInput!]!) {
    updatePricingPlan(input: { id: $id, name: $name, pricings: $pricings }) {
      success
      errors
    }
  }
`
